import { RefreshCw, X } from 'lucide-react';
import type { FC } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

// The SW registration checks for updates on page load; a riding session keeps one page
// alive for hours, so re-check on an interval too.
const UPDATE_CHECK_MS = 60 * 60 * 1000;

/**
 * "New version available" banner. The service worker is registered in prompt mode
 * (vite.config.ts): a freshly downloaded version waits instead of activating mid-session,
 * and this banner offers the reload that switches over. Dismissing keeps the current
 * version until the next full restart.
 */
const UpdatePrompt: FC = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => void registration.update().catch(() => undefined), UPDATE_CHECK_MS);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="mg-update-banner" role="status">
      <span className="mg-update-text">A new version of MotoGo is ready.</span>
      <button className="mg-btn mg-btn-primary mg-update-btn" onClick={() => void updateServiceWorker(true)}>
        <RefreshCw size={18} /> Refresh
      </button>
      <button className="mg-icon-btn" onClick={() => setNeedRefresh(false)} aria-label="Not now" title="Not now">
        <X size={20} />
      </button>
    </div>
  );
};

export default UpdatePrompt;
